
import React from "react";
import {
    House,
    UsersRound,
    CalendarDays,
    MessageCircle,
    Ellipsis,
    Sparkles
} from "lucide-react";
import { canAccessMobileSection, moreSections } from "./mobileNavigation";

export default function MobileBottomNav({
    section,
    setSection,
    permissions = {}
}) {

    const items = [
        {
            key: "inicio",
            label: "Inicio",
            icon: House
        },
        {
            key: "vexadent-ai",
            label: "VexaDent AI",
            icon: Sparkles
        },
        {
            key: "pacientes",
            label: "Pacientes",
            icon: UsersRound
        },
        {
            key: "citas",
            label: "Citas",
            icon: CalendarDays
        },
        {
            key: "whatsapp",
            label: "WhatsApp",
            icon: MessageCircle
        },
        {
            key: "mas",
            label: "Más",
            icon: Ellipsis
        }
    ].filter(item => canAccessMobileSection(item.key, permissions));

    return (

        <nav
            className="vd-mobile-bottom-nav"
            aria-label="Navegación principal"
            style={{
                position: "fixed",
                left: 14,
                right: 14,
                bottom: "calc(12px + env(safe-area-inset-bottom))",
                height: 68,
                background:
                    "rgba(255,255,255,0.96)",
                backdropFilter:
                    "blur(18px)",
                WebkitBackdropFilter:
                    "blur(18px)",
                border:
                    "1px solid rgba(226,232,240,0.9)",
                borderRadius: 22,
                boxShadow:
                    "0 8px 30px rgba(15,23,42,0.12)",
                display: "flex",
                alignItems: "stretch",
                justifyContent:
                    "space-around",
                zIndex: 1000,
                padding:
                    "4px 4px",
                boxSizing: "border-box"
            }}
        >

            {items.map((item) => {

                const active =
                    section === item.key ||
                    (item.key === "mas" && moreSections.includes(section));

                const Icon =
                    item.icon;

                return (

                    <button
                        key={item.key}
                        data-tour={`mobile-${item.key === "inicio" ? "home" : item.key === "citas" ? "appointments" : item.key === "mas" ? "more" : item.key}`}
                        type="button"
                        onClick={() =>
                            setSection(
                                item.key
                            )
                        }
                        aria-label={
                            item.label
                        }
                        aria-current={active ? "page" : undefined}
                        style={{
                            flex: 1,
                            minWidth: 0,
                            border: "none",
                            background:
                                "transparent",
                            display: "flex",
                            flexDirection:
                                "column",
                            alignItems:
                                "center",
                            justifyContent:
                                "center",
                            gap: 5,
                            padding:
                                "6px 1px",
                            cursor: "pointer",
                            color: active
                                ? "#2563eb"
                                : "#64748b",
                            transition:
                                "color 0.18s ease",
                            WebkitTapHighlightColor:
                                "transparent"
                        }}
                    >

                        <div
                            style={{
                                width: 34,
                                height: 30,
                                borderRadius: 10,
                                display: "flex",
                                alignItems:
                                    "center",
                                justifyContent:
                                    "center",
                                background:
                                    active
                                        ? "#eff6ff"
                                        : "transparent",
                                transition:
                                    "all 0.18s ease"
                            }}
                        >

                            <Icon
                                size={20}
                                strokeWidth={
                                    active
                                        ? 2.2
                                        : 1.8
                                }
                            />

                        </div>

                        <span
                            style={{
                                fontSize:
                                    item.key === "vexadent-ai"
                                        ? 9
                                        : 10,
                                lineHeight: 1,
                                fontWeight:
                                    active
                                        ? 700
                                        : 500,
                                whiteSpace:
                                    "nowrap",
                                maxWidth: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                letterSpacing:
                                    "-0.2px"
                            }}
                        >
                            {item.label}
                        </span>

                    </button>

                );

            })}

        </nav>

    );

}
